import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';
import { IconColor } from '../avatar/avatar.component';

@Component({
  selector: 'app-menu-item[labelKey]',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {
  @Input() labelKey!: LocLabel | string;
  @Input() icon: string | null = null;
  @Input() iconColor: IconColor = 'primary';
  @Input() textColor: IconColor = 'black';

  @Output() onClick = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
}
